import { regionsFilters } from "./regionsFilters";

export const regions = {
  namespaced: true,
  modules: {
    regionsFilters
  }
};
